import React, { useState } from "react";
import loanUpdateService from "../../../../services/_axiosServices/sweep/loan-update";
import { Loader, Error } from "../../components";

export default function Report() {
  const [loading, setLoading] = useState(true);
  const [code, setCode] = useState("");
  const [ref, setRef] = useState("");
  const [data, setData] = useState(false);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    if (code.length < 1) {
      setData(false);
      return;
    }
    setLoading(true);
    await loanUpdateService
      .validateRepushLoanBalanceUpdateTransaction(code, ref)
      .then((res: any) => {
        // console.log(res);
        setLoading(false);
        setData(res.data);
      })
      .catch((err: any) => {
        setError(true);
        setLoading(false);
        console.log(err.message);
      });
  };

  return (
    <div className="container-fluid relative animatedParent animateOnce">
      <div className="animated fadeInUpShort go">
        <div className="row my-3 mx-2">
          <h3>
            <b>Validate Repush Loan Balance</b>
          </h3>
        </div>
        <div className="card no-b">
          <div className="card-body">
            <div className="card-title">
              <div className="page">
                <div className="page-inner">
                  <div className="btn-toolbar justify-content-between">
                    <div className="btn-group">
                      <input
                        name="institutionCode"
                        onChange={(e) => setCode(e.target.value)}
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Institution Code"
                        required
                      />
                      <input
                        name="recovaReferenceNo"
                        onChange={(e) => setRef(e.target.value)}
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Recova Reference No "
                        required
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={fetchData}
                      >
                        Go
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive text-nowrap">
                    {loading && <Loader />}

                    {!loading && !error && (
                      <table className="table table-hover table-content table-striped table-bordered table-sm paged-output">
                        <thead>
                          <tr>
                            <th>Valid Loan Balance Update</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{data ? "True" : "False"}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}

                    {error && !loading && <Error />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
